export default {
  "autresServices": {
    "heroTitle": "Other Technical Services",
    "heroSubtitle": "Complementary services to support your projects from A to Z with our multidisciplinary technical expertise",
    "intro": "Beyond our energy solutions, IS TELECOM offers a comprehensive range of technical services to ensure the success of your projects.",
    "prestationsLabel": "Our Services:",
    "subServicesLabel": "Related Services:",
    "ctaLink": "Discuss Your Project",
    "whyUs": {
      "title": "Why choose our technical services?",
      "items": [
        {"title": "Recognized Certifications", "desc": "Our teams are certified to the most demanding international standards (ISO, CE, TUV)."},
        {"title": "Multidisciplinary Team", "desc": "Engineers, technicians, architects and consultants brought together to cover all aspects of your project."},
        {"title": "Quality Guarantee", "desc": "Every service is checked, validated and guaranteed. We only deliver what meets our standards."}
      ]
    },
    "cta": {
      "title": "A complex project? We have the solution.",
      "subtitle": "Whatever your technical need, our multidisciplinary team finds the right answer.",
      "button": "Talk to an Expert"
    },
    "services": [
      {
        "id": "audit",
        "title": "Audit & Consulting",
        "fullDesc": "Our team of experts performs comprehensive energy audits to analyze your existing installations and identify areas for optimization. Each recommendation is tailored to the specific needs of your project.",
        "details": ["Complete on-site energy diagnosis", "Historical consumption analysis", "Technical and economic feasibility study", "Personalized recommendations with estimated ROI", "Support in seeking financing"]
      },
      {
        "id": "expertise",
        "title": "Technical Expertise",
        "fullDesc": "Our technical experts intervene to validate the compliance of your installations, certify performance and propose optimizations. We guarantee the safety, reliability and performance of your energy systems.",
        "details": ["Judicial and technical expertise", "Certification of existing installations", "Energy performance optimization", "Regulatory compliance verification", "Detailed expert reports"]
      },
      {
        "id": "informatique",
        "title": "IT Services",
        "fullDesc": "We deploy complete IT infrastructures to support your energy projects: networks, servers, monitoring systems, energy management platforms and cybersecurity solutions.",
        "details": ["Local and wide area network deployment", "Server and data center configuration", "Energy monitoring platforms", "IT security and cybersecurity", "Technical support and IT maintenance"]
      },
      {
        "id": "environnement",
        "title": "Environmental Services",
        "fullDesc": "We support your projects in their environmental compliance: impact studies, carbon footprint, ecological certifications and sustainable development consulting.",
        "details": ["Environmental impact studies (EIA)", "Carbon footprint and reduction strategy", "Environmental certifications (LEED, BREEAM)", "Circular economy consulting", "Electronic waste management"]
      },
      {
        "id": "btp",
        "title": "Metal Construction & Civil Engineering",
        "fullDesc": "Our civil engineering and metal construction department manufactures and installs custom structures for your energy projects: frameworks, panel supports, technical buildings and civil engineering infrastructure.",
        "details": ["Custom metal structure fabrication", "Civil engineering and specialized foundations", "Technical building and substation construction", "Fencing installation and site security", "Renovation and extension works"]
      },
      {
        "id": "telecom",
        "title": "Telecommunications",
        "fullDesc": "IS TELECOM deploys complete telecommunications infrastructure: tower and pylon installation, fiber optic and wireless network deployment, radio equipment maintenance and connectivity solutions for rural and urban areas.",
        "details": ["Telecom tower and pylon installation", "Fiber optic and wireless network deployment", "Preventive and corrective radio equipment maintenance", "Connectivity solutions for isolated rural areas", "Integration with existing solar infrastructure"]
      },
      {
        "id": "transport",
        "title": "Transport & Logistics",
        "fullDesc": "We handle the transport and logistics of your energy and telecom equipment across Africa and beyond. From specialized handling to turnkey on-site delivery, we guarantee the safety and timeliness of your shipments.",
        "details": ["Road and maritime heavy equipment transport", "Specialized handling of solar panels and batteries", "Project logistics and supply chain", "Customs and administrative shipment management", "Turnkey delivery to isolated sites"],
        "subServices": [
          {
            "id": "location",
            "title": "Equipment Rental",
            "desc": "We offer heavy machinery and specialized equipment rental for your construction sites: cranes, aerial work platforms, bulldozers, excavators, compactors and dump trucks. Our equipment is regularly maintained and available with or without a qualified operator according to your needs.",
            "details": ["Mobile and tower crane rental", "Aerial work platforms and telehandlers", "Earthmoving equipment: bulldozers, excavators, graders", "Compactors, road rollers and pavers", "Dump trucks and material transport vehicles", "Short or long-term contracts, with or without operator"]
          }
        ]
      }
    ]
  }
};